import { createContext, useContext, useState } from "react";
import { Settings } from "@config/tenants/settings";

type ContextType = {
  slug: string | null;
  config: {
    type: string;
    [key: string]: string;
  } | null;
  setTab(slug: string): void;
};

const ExtraTabContext = createContext<ContextType>({
  slug: "",
  config: null,
  setTab: (slug: string) => {
    console.warn(slug);
  },
});

export const useExtraTab = () => useContext<ContextType>(ExtraTabContext);

export function ExtraTabProvider({ children }) {
  const [slug, setSlug] = useState(null);
  const [config, setConfig] = useState(null);

  const setTab = (slug: string) => {
    const tab = Settings.extraTabs.find((tab) => tab.slug === slug);
    if (tab) {
      setSlug(tab.slug);
      setConfig(tab.config);
    } else {
      setSlug(null);
      setConfig(null);
    }
  };

  const value = {
    slug,
    config,
    setTab,
  };

  return (
    <ExtraTabContext.Provider value={value}>
      {children}
    </ExtraTabContext.Provider>
  );
}
